/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserHistoryObservedEmergencyModel } from './UserHistoryObservedEmergencyModel';
import {
    UserHistoryObservedEmergencyModelFromJSON,
    UserHistoryObservedEmergencyModelFromJSONTyped,
    UserHistoryObservedEmergencyModelToJSON,
    UserHistoryObservedEmergencyModelToJSONTyped,
} from './UserHistoryObservedEmergencyModel';

/**
 * 
 * @export
 * @interface UserHistoryOnAzure
 */
export interface UserHistoryOnAzure {
    /**
     * 
     * @type {string}
     * @memberof UserHistoryOnAzure
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {{ [key: string]: UserHistoryObservedEmergencyModel; }}
     * @memberof UserHistoryOnAzure
     */
    observed_emergencies?: { [key: string]: UserHistoryObservedEmergencyModel; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserHistoryOnAzure
     */
    read_inbox_message_names?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserHistoryOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof UserHistoryOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the UserHistoryOnAzure interface.
 */
export function instanceOfUserHistoryOnAzure(value: object): value is UserHistoryOnAzure {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function UserHistoryOnAzureFromJSON(json: any): UserHistoryOnAzure {
    return UserHistoryOnAzureFromJSONTyped(json, false);
}

export function UserHistoryOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserHistoryOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'org_code': json['org_code'],
        'observed_emergencies': json['observed_emergencies'] == null ? undefined : (mapValues(json['observed_emergencies'], UserHistoryObservedEmergencyModelFromJSON)),
        'read_inbox_message_names': json['read_inbox_message_names'] == null ? undefined : json['read_inbox_message_names'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function UserHistoryOnAzureToJSON(json: any): UserHistoryOnAzure {
    return UserHistoryOnAzureToJSONTyped(json, false);
}

export function UserHistoryOnAzureToJSONTyped(value?: UserHistoryOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'org_code': value['org_code'],
        'observed_emergencies': value['observed_emergencies'] == null ? undefined : (mapValues(value['observed_emergencies'], UserHistoryObservedEmergencyModelToJSON)),
        'read_inbox_message_names': value['read_inbox_message_names'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

